import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import useStatsStore from "../../../store/stats.store";

import TableDashBoard from "../../TableDashBoard";

import "../teamAssignment.scss";
import Filter from "../../filter";

export default function TeamAssignmentNegativeFeedbacks({currentView,cb}) {

  const {teamsDashConsolidatedStatsNegativeFeedback,getTeamsDashBoardConsolidatedStatsNegativeFeedback,teamsDashConsolidatedStatsNegativeFeedbackCount} = useStatsStore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  

  useEffect(() => {
    //getAllJds();
  }, []);

    const resumeRejectionList = [
    "Sr. No.",
    "Client",
    "TA",
    "Job Title",
    "SPOC",
    "Assigned To",
    "Screen Rejected",
    "Interview Rejected",
    "Interviews Candidate Drop",
    "No Shows",
    "Interviews Candidate NP",
    "Panel Not Joined",
    "No Panel",
  ];
  const resumeRejectionData = teamsDashConsolidatedStatsNegativeFeedback?.rejections?.map((rejection, idx) => {
    return {
      id: idx + 1 + (pageSize *(currentPage-1)),    
      client_name: rejection?.client,
      ta_name: rejection?.ta,
      title: '['+rejection?.qhcompanyjid+'] '+rejection?.title,
      SPOC: rejection?.spoc,
      assigned_to: rejection?.assignedto,
      numScreenRejected: rejection?.numscreenrejected===0?"-":rejection?.numscreenrejected,
      numInterviewRejected: rejection?.numinterviewrejected===0?"-":rejection?.numinterviewrejected,
      numInterviewCandidateDrop: rejection?.numinterviewcandidatedrop===0?"-":rejection?.numinterviewcandidatedrop,
      numInterviewNoShow: rejection?.numinterviewnoshow===0?"-":rejection?.numinterviewnoshow,
      numInterviewCandidateNP: rejection?.numinterviewcandidatenp===0?"-":rejection?.numinterviewcandidatenp,
      numInterviewPanelNotJoined: rejection?.numinterviewpanelnotjoined===0?"-":rejection?.numinterviewpanelnotjoined,
      numInterviewNoPanel: rejection?.numinterviewnopanel===0?"-":rejection?.numinterviewnopanel,
    };
  }); 

  return (
    <div className="teamAssignmentPages-wrapper">
      <Filter
        filtername = {"getTeamsDashBoardFilter"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}  
        initClient={"All"}     
        enableDuration
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs              
        handleFilter={cb}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}         
      />      
      <div></div>

      {teamsDashConsolidatedStatsNegativeFeedback ? (
        <>

           {currentView==="Rejections/No Shows"?
              <>
                <TableDashBoard
                  isClickable={true}
                  isJDPage={true}
                  titleList={resumeRejectionList}
                  data={resumeRejectionData}
                />             
              </>:<></>
            }                                                   
        </>
        
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={teamsDashConsolidatedStatsNegativeFeedbackCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />            
    </div>
  );
}
